import { Injectable } from '@angular/core';
import { IPassesResponse, PassesResponse } from '../models/passes-response.model';
import { SpinnerService } from './spinner.service';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { ToastService } from './toast.service';
import { UtilService } from './util.service';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, map } from 'rxjs';
import { IServerResponse, ServerResponse } from '../models/server-response.model';

@Injectable({
  providedIn: 'root'
})
export class PassService {

  public loading: boolean = false;

  constructor(
    private authService: AuthService,
    private http: HttpClient,
    public spinnerService: SpinnerService,
    private toastService: ToastService,
    private utilService: UtilService
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                            ANCHOR getByHouseFlat                           */
  /* -------------------------------------------------------------------------- */
  // region getByHouseFlat
  async getByHouseFlat(
    neighborhoodId: string,
    streetBuildingId: string,
    houseFlatId: string,
    fromDate?: string,
    toDate?: string
  ): Promise<PassesResponse> {

    let passesResponse: PassesResponse = new PassesResponse({
      canceled: [],
      declined: [],
      overdue: [],
      active: [],
      history: []
    });

    this.spinnerService.loading = true;
    this.spinnerService.message = 'Cargando pases...';

    this.loading = true;

    try {
      let urlApi = `${environment.urlApi}/neighborhoods/${neighborhoodId}/streets-buildings/${streetBuildingId}/houses-flats/${houseFlatId}/passes`;
      if (fromDate) urlApi += `?start_date=${fromDate}`;
      if (toDate) urlApi += `${fromDate ? '&' : '?'}end_date=${toDate}`;

      const token = await this.authService.getToken();
      const headers = this.utilService.headers(token);

      const response = await firstValueFrom(
        this.http.get<IServerResponse<IPassesResponse>>(
          urlApi, 
          { headers }
        ).pipe(
          map(res => new ServerResponse<IPassesResponse>(res))
        )
      );

      if (response.statusCode === 200) {

        passesResponse = new PassesResponse(response.data!);
        
      }

    } catch (error) {
      console.log('Error:', error);

      this.toastService.show({
        header: 'Error al cargar pases',
        body: `${error}`,
        classname: 'bg-danger text-white'
      });

    } finally {
      this.loading = false;

      this.spinnerService.loading = false;
      this.spinnerService.message = '';
    }

    return passesResponse;
  }

  async getByNeighborhood(
    neighborhoodId: string,
    fromDate?: string,
    toDate?: string
  ): Promise<PassesResponse> {

    let passesResponse: PassesResponse = new PassesResponse({
      canceled: [],
      declined: [],
      overdue: [],
      active: [],
      history: []
    });

    this.spinnerService.loading = true;
    this.spinnerService.message = 'Cargando pases...';

    this.loading = true;

    try {
      let urlApi = `${environment.urlApi}/neighborhoods/${neighborhoodId}/visits/passes`;
      if (fromDate) urlApi += `?start_date=${fromDate}`;
      if (toDate) urlApi += `${fromDate ? '&' : '?'}end_date=${toDate}`;

      const token = await this.authService.getToken();
      const headers = this.utilService.headers(token);

      const response = await firstValueFrom(
        this.http.get<IServerResponse<IPassesResponse>>(
          urlApi, 
          { headers }
        ).pipe(
          map(res => new ServerResponse<IPassesResponse>(res))
        )
      );

      if (response.statusCode === 200) {

        passesResponse = new PassesResponse(response.data!);
        
      }

    } catch (error) {
      console.log('Error:', error);

      this.toastService.show({
        header: 'Error al cargar pases',
        body: `${error}`,
        classname: 'bg-danger text-white'
      });

    } finally {
      this.loading = false;

      this.spinnerService.loading = false;
      this.spinnerService.message = '';
    }

    return passesResponse;
  }
}
